"use strict";
var angular = require("angular");

var module = angular.module("roles.module", ["common.module"]);
require("./states.js").configure(module);

module.controller("viewRoles.controller", require("./controllers/viewRoles.controller"));
module.controller("viewEditRole.controller", require("./controllers/viewEditRole.controller"));
module.factory("roles.service", require("./services/roles.service"));
module.directive("viewEditPermissionValue", require("./directives/viewEditPermissionValue.directive"));